import { SearchOffOutlined } from '@mui/icons-material';
import { Typography, Stack } from '@mui/material';

interface ContentNotFoundProps {
  title: string;
  subtitle: string;
}

const ContentNotFound: React.FC<ContentNotFoundProps> = ({ title, subtitle }) => {
  return (
    <Stack direction="column" justifyContent="center" alignItems="center" color="text.secondary">
      <SearchOffOutlined sx={{ fontSize: '68px' }} />
      <Typography variant="h6">{title}</Typography>
      <Typography variant="body2">{subtitle}</Typography>
    </Stack>
  );
};

export default ContentNotFound;
